<template>
    <div>
        <el-dialog
            title="情报局"
            :visible.sync="ReportDialogVisible"
            :append-to-body="true"
            width="1100px"
            :center="true"
            top="10px"
            :close-on-click-modal="false"
            :before-close="() => $emit('ExitReportDialog')"
            v-loading.fullscreen.lock="login_loading"
        >
            <div style="margin-bottom: 5px;text-align: center;">
                <el-radio-group v-model="type" size="small">
                    <el-radio-button label="online">在线玩家</el-radio-button>
                    <el-radio-button label="week">上周周报</el-radio-button>
                    <el-radio-button label="month">上月月报</el-radio-button>
                    <el-radio-button label="char">数据分析</el-radio-button>
                </el-radio-group>
            </div>
            <el-descriptions
                direction="vertical"
                :column="2"
                :labelStyle="{'text-align':'center','width':'33%'}"
                :contentStyle="{'text-align': 'center'}"
                border
                v-if="type === 'online'"
            >
                <el-descriptions-item>
                    <template slot="label">
                        <span>在线等待中</span>
                    </template>
                    <div v-for="item in OnLineDate.wait" :key="item.with_player_id">
                        <div v-if="item.gender === 1">
                            <img :src="$store.state.baseURL+'icon/xingbienan.png'" height="10px">
                            <span style="color: #2894FF;font-family: HarmonyOS_Sans_Light;">{{ item.name }}</span>
                        </div>
                        <div v-else-if="item.gender === 2">
                            <img :src="$store.state.baseURL+'icon/xingbienv.png'" height="10px">
                            <span style="color: #FF60AF;font-family: HarmonyOS_Sans_Light;">{{ item.name }}</span>
                        </div>
                    </div>
                </el-descriptions-item>
                <el-descriptions-item v-if="OnLineDate.gm.length == 0">
                    <template slot="label">
                        <span>游戏对局中</span>
                    </template>
                    <fieldset v-for="(item,index) in OnLineDate.ing" :key="index">
                        <legend class="legendc">房间{{ index+1 }}({{ item.length }}人)</legend>
                        <div v-for="ing_user in item" :key="ing_user.with_player_id">
                            <div v-if="ing_user.gender === 1">
                                <img :src="$store.state.baseURL+'icon/xingbienan.png'" height="10px">
                                <span style="color: #2894FF;font-family: HarmonyOS_Sans_Light;">{{ ing_user.name }}</span>
                                <span v-if="ing_user.state === 3" style="font-family: HarmonyOS_Sans_Light;">（逃跑）</span>
                            </div>
                            <div v-else-if="ing_user.gender === 2">
                                <img :src="$store.state.baseURL+'icon/xingbienv.png'" height="10px">
                                <span style="color: #FF60AF;font-family: HarmonyOS_Sans_Light;">{{ ing_user.name }}</span>
                                <span v-if="ing_user.state === 3" style="font-family: HarmonyOS_Sans_Light;">（逃跑）</span>
                            </div>
                        </div>
                    </fieldset>
                </el-descriptions-item>
                <el-descriptions-item v-else>
                    <template slot="label">
                        <span>上帝视角（限时开放）</span>
                    </template>
                    <fieldset v-for="(item,index) in OnLineDate.gm" :key="index">
                        <legend class="legendc">房间{{ index+1 }}({{ item.length }}人)</legend>
                        <div v-for="gm_user in item" :key="gm_user.with_player_id">
                            <div v-if="gm_user.gender === 1">
                                <el-row>
                                    <el-col :span="10" style="text-align: right;">
                                        <img :src="$store.state.baseURL+'icon/xingbienan.png'" height="10px">
                                        <span style="color: #2894FF;font-family: HarmonyOS_Sans_Light;">{{ gm_user.name }}</span>
                                    </el-col>
                                    <el-col :span="4">
                                        <!-- 阵营 -->
                                        <el-tag v-if="gm_user.identity == 0" effect="plain" size="mini">军</el-tag>
                                        <el-tag v-else-if="gm_user.identity == 1" type="danger" effect="plain" size="mini">潜</el-tag>
                                        <el-tag v-else type="success" effect="plain" size="mini">酱</el-tag>
                                    </el-col>
                                    <!-- 角色 -->
                                    <el-col :span="10" style="text-align: left;">
                                        <span v-if="gm_user.role_gender === 1">
                                            <img :src="$store.state.baseURL+'icon/xingbienan.png'" height="10px"><span style="color: #2894FF;">{{ gm_user.role_name }}</span>
                                        </span>
                                        <span v-else>
                                            <img :src="$store.state.baseURL+'icon/xingbienv.png'" height="10px"><span style="color: #FF60AF;">{{ gm_user.role_name }}</span>
                                        </span>
                                        <span v-if="gm_user.state === 3" style="font-family: HarmonyOS_Sans_Light;">（逃跑）</span>
                                    </el-col>
                                </el-row>
                            </div>
                            <div v-else-if="gm_user.gender === 2">
                                <el-row>
                                    <el-col :span="10" style="text-align: right;">
                                        <img :src="$store.state.baseURL+'icon/xingbienv.png'" height="10px">
                                        <span style="color: #FF60AF;font-family: HarmonyOS_Sans_Light;">{{ gm_user.name }}</span>
                                    </el-col>
                                    <el-col :span=4>
                                        <!-- 阵营 -->
                                        <el-tag v-if="gm_user.identity == 0" effect="plain" size="mini">军</el-tag>
                                        <el-tag v-else-if="gm_user.identity == 1" type="danger" effect="plain" size="mini">潜</el-tag>
                                        <el-tag v-else type="success" effect="plain" size="mini">酱</el-tag>
                                    </el-col>
                                    <el-col :span="10" style="text-align: left;">
                                        <!-- 角色 -->
                                        <span v-if="gm_user.role_gender === 1">
                                        <img :src="$store.state.baseURL+'icon/xingbienan.png'" height="10px"><span style="color: #2894FF;">{{ gm_user.role_name }}</span>
                                        </span>
                                        <span v-else>
                                            <img :src="$store.state.baseURL+'icon/xingbienv.png'" height="10px"><span style="color: #FF60AF;">{{ gm_user.role_name }}</span>
                                        </span>
                                        <span v-if="gm_user.state === 3" style="font-family: HarmonyOS_Sans_Light;">（逃跑）</span>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                    </fieldset>
                </el-descriptions-item>
            </el-descriptions>
            <el-descriptions
                :column="1"
                :labelStyle="{'width':'110px','text-align':'center'}"
                :contentStyle="{'text-align': 'center'}"
                size="small"
                border
                v-else-if="type === 'week'"
            >
                <el-descriptions-item>
                    <template slot="label">
                        <span>最<span style="font-weight: bold;font-size: 16px;color: #EA0000;">强</span>角色</span>
                    </template>
                    <span>【</span>
                    <span style="font-weight: bold;font-size: 16px;color: #EA0000;">{{ WeeklyData.role_win_arr.role }}</span>
                    <span>】上周</span>
                    <span style="font-weight: bold;color: #EA0000;">胜场最多</span>
                    <span>，所有玩家合计胜利</span>
                    <span style="font-weight: bold;font-size: 16px;color: #EA0000;">{{ WeeklyData.role_win_arr.num }}</span>
                    <span>场</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>最<span style="font-weight: bold;font-size: 16px;color: #000000;">惨</span>角色</span>
                    </template>
                    <span>【</span>
                    <span style="font-weight: bold;font-size: 16px;color: #000000;">{{ WeeklyData.role_lose_arr.role }}</span>
                    <span>】上周</span>
                    <span style="font-weight: bold;color: #000000;">败场最多</span>
                    <span>，所有玩家合计失败</span>
                    <span style="font-weight: bold;font-size: 16px;color: #000000;">{{ WeeklyData.role_lose_arr.num }}</span>
                    <span>场</span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>我的对局</span>
                    </template>
                    <div v-if="WeeklyData.my_all_num">
                        <span>上周对局</span>
                        <span style="font-weight: bold;font-size: 16px;">{{ WeeklyData.my_all_num }}</span>
                        <span>场，胜利</span>
                        <span style="font-weight: bold;font-size: 16px;color: #EA0000;">{{ WeeklyData.my_win_num }}</span>
                        <span>场，胜率</span>
                        <span style="font-weight: bold;font-size: 16px;">{{ WeeklyData.my_win_ratio }}</span>
                    </div>
                    <div v-else style="font-weight: bold;font-size: 16px;">无</div>
                    
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>我的<span style="font-weight: bold;font-size: 16px;color: #8600FF;">幸运</span>角色</span>
                    </template>
                    <div v-if="WeeklyData.my_lucky_role_arr.num">
                        <span>【</span>
                        <span style="font-weight: bold;font-size: 16px;color: #8600FF;">{{ WeeklyData.my_lucky_role_arr.role }}</span>
                        <span>】为我上周</span>
                        <span style="font-weight: bold;color: #EA0000;">胜场最多</span>
                        <span>的角色，胜利</span>
                        <span style="font-weight: bold;font-size: 16px;color: #8600FF;">{{ WeeklyData.my_lucky_role_arr.num }}</span>
                        <span>场</span>
                    </div>
                    <div v-else style="font-weight: bold;font-size: 16px;">无</div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>我的<span style="font-weight: bold;font-size: 16px;color: #EA0000;">最佳</span>搭档</span>
                    </template>
                    <div v-if="WeeklyData.my_win_partner.num">
                        <span>【</span>
                        <span style="font-weight: bold;font-size: 16px;color: #EA0000;">{{ WeeklyData.my_win_partner.userNickName }}</span>
                        <span>】为上周与我共同</span>
                        <span style="font-weight: bold;color: #EA0000;">胜利最多</span>
                        <span>的玩家，共同胜利</span>
                        <span style="font-weight: bold;font-size: 16px;color: #EA0000;">{{ WeeklyData.my_win_partner.num }}</span>
                        <span>场</span>
                    </div>
                    <div v-else style="font-weight: bold;font-size: 16px;">无</div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>我的<span style="font-weight: bold;font-size: 16px;color: #000000;">最坑</span>搭档</span>
                    </template>
                    <div v-if="WeeklyData.my_lose_partner.num">
                        <span>【</span>
                        <span style="font-weight: bold;font-size: 16px;color: #000000;">{{ WeeklyData.my_lose_partner.userNickName }}</span>
                        <span>】为上周与我共同</span>
                        <span style="font-weight: bold;color: #000000;">失败最多</span>
                        <span>的玩家，共同失败</span>
                        <span style="font-weight: bold;font-size: 16px;color: #000000;">{{ WeeklyData.my_lose_partner.num }}</span>
                        <span>场</span>
                    </div>
                    <div v-else style="font-weight: bold;font-size: 16px;">无</div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>我的<span style="font-weight: bold;font-size: 16px;color: #64A600;">下酒菜</span></span>
                    </template>
                    <div v-if="WeeklyData.my_xiajiucai_partner.num">
                        <span>【</span>
                        <span style="font-weight: bold;font-size: 16px;color: #64A600;">{{ WeeklyData.my_xiajiucai_partner.userNickName }}</span>
                        <span>】上周与我共同对局，</span>
                        <span style="font-weight: bold;color: #EA0000;">我胜</span>
                        <span style="font-weight: bold;color: #000000;">ta败</span>
                        <span>场数最多，为</span>
                        <span style="font-weight: bold;font-size: 16px;color: #64A600;">{{ WeeklyData.my_xiajiucai_partner.num }}</span>
                        <span>场</span>
                    </div>
                    <div v-else style="font-weight: bold;font-size: 16px;">无</div>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>我的<span style="font-weight: bold;font-size: 16px;color: #AE57A4;">克星</span></span>
                    </template>
                    <div v-if="WeeklyData.my_kexing_partner.num">
                        <span>【</span>
                        <span style="font-weight: bold;font-size: 16px;color: #AE57A4;">{{ WeeklyData.my_kexing_partner.userNickName }}</span>
                        <span>】上周与我共同对局，</span>
                        <span style="font-weight: bold;color: #EA0000;">ta胜</span>
                        <span style="font-weight: bold;color: #000000;">我败</span>
                        <span>场数最多，为</span>
                        <span style="font-weight: bold;font-size: 16px;color: #AE57A4;">{{ WeeklyData.my_kexing_partner.num }}</span>
                        <span>场</span>
                    </div>
                    <div v-else style="font-weight: bold;font-size: 16px;">无</div>
                </el-descriptions-item>
            </el-descriptions>
            <el-descriptions
                :column="1"
                :labelStyle="{'width':'110px','text-align':'center'}"
                :contentStyle="{'text-align': 'center'}"
                size="small"
                border
                v-else-if="type === 'month'"
            >
                <el-descriptions-item>
                    <template slot="label">
                        <span>上月战绩</span>
                    </template>
                    <span>你上月共进行<span style="font-size: 16px;color: #2828FF;">{{ YearlyData.count_play_num }}</span>场对局,</span>
                    <span>获胜<span style="font-size: 16px;color: #2828FF;">{{ YearlyData.count_play_win_num }}</span>场,</span>
                    <span>胜率竟然高达<span style="font-size: 16px;color: #2828FF;">{{ YearlyData.count_play_win_ratio }}%</span></span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span><span style="font-size: 16px;color: #7D7DFF;">身份</span>模式</span>
                    </template>
                    <span>你上月共参与<span style="font-weight: bold;color: #7D7DFF;">身份</span>模式<span style="font-size: 16px;color: #7D7DFF;">{{ YearlyData.count_play_shenfen_num }}</span>场，</span>
                    <span>胜利<span style="font-size: 16px;color: #7D7DFF;">{{ YearlyData.count_play_shenfen_win_num }}</span>场，胜率<span style="font-size: 16px;color: #7D7DFF;">{{ YearlyData.count_play_shenfen_win_ratio }}%</span></span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span><span style="font-size: 16px;color: #BB5E00;">3V3</span>模式</span>
                    </template>
                    <span>你上月共参与<span style="font-weight:bold;color: #BB5E00;">3V3</span>模式<span style="font-size: 16px;color: #BB5E00;">{{ YearlyData.count_play_sansan_num }}</span>场，</span>
                    <span>胜利<span style="font-size: 16px;color: #BB5E00;">{{ YearlyData.count_play_sansan_win_num }}</span>场，胜率<span style="font-size: 16px;color: #BB5E00;">{{ YearlyData.count_play_sansan_win_ratio }}%</span></span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span><span style="font-size: 16px;color: #00BB00;">酱油</span>模式</span>
                    </template>
                    <span>你上月共参与<span style="font-weight: bold;color: #00BB00;">酱油</span>模式<span style="font-size: 16px;color: #00BB00;">{{ YearlyData.count_play_jiangyou_num }}</span>场，</span>
                    <span>胜利<span style="font-size: 16px;color: #00BB00;">{{ YearlyData.count_play_jiangyou_win_num }}</span>场，胜率<span style="font-size: 16px;color: #00BB00;">{{ YearlyData.count_play_jiangyou_win_ratio }}%</span></span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span><span style="font-size: 16px;color: #0080FF;">军情</span>身份</span>
                    </template>
                    <span>你上月共获得<span style="font-weight: bold;color: #0080FF;">军情</span>身份<span style="font-size: 16px;color: #0080FF;">{{ YearlyData.count_play_jun_num }}</span>场，</span>
                    <span>胜利<span style="font-size: 16px;color: #0080FF;">{{ YearlyData.count_play_jun_win_num }}</span>场，胜率<span style="font-size: 16px;color: #0080FF;">{{ YearlyData.count_play_jun_win_ratio }}%</span></span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span><span style="font-size: 16px;color: #CE0000;">潜伏</span>身份</span>
                    </template>
                    <span>你上月共获得<span style="font-weight:bold;color: #CE0000;">潜伏</span>身份<span style="font-size: 16px;color: #CE0000;">{{ YearlyData.count_play_qian_num }}</span>场，</span>
                    <span>胜利<span style="font-size: 16px;color: #CE0000;">{{ YearlyData.count_play_qian_win_num }}</span>场，胜率<span style="font-size: 16px;color: #CE0000;">{{ YearlyData.count_play_qian_win_ratio }}%</span></span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span><span style="font-size: 16px;color: #00BB00;">酱油</span>身份</span>
                    </template>
                    <span>你上月共获得<span style="font-weight: bold;color: #00BB00;">酱油</span>身份<span style="font-size: 16px;color: #00BB00;">{{ YearlyData.count_play_jiang_num }}</span>场，</span>
                    <span>胜利<span style="font-size: 16px;color: #00BB00;">{{ YearlyData.count_play_jiang_win_num }}</span>场，胜率<span style="font-size: 16px;color: #00BB00;">{{ YearlyData.count_play_jiang_win_ratio }}%</span></span>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>常用<span style="font-size: 16px;">角色</span></span>
                    </template>
                    <el-row :gutter="20">
                        <el-col :span="8" v-for="item in YearlyData.my_max_role_arr" :key="item.role_name">
                            <el-col :span="10">
                                <div style="text-align: center;"><img :src="item.role_picture" height="120px" alt="" style="border-radius: 10px;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="text-align: left;margin-top: 30px;">
                                    <img v-if="item.role_gender === 1" :src="$store.state.baseURL+'icon/xingbienan.png'" height="14px"><span v-if="item.role_gender === 1" style="color: #2894FF;">{{ item.role_name }}</span>
                                    <img v-if="item.role_gender === 2" :src="$store.state.baseURL+'icon/xingbienv.png'" height="14px"><span v-if="item.role_gender === 2" style="color: #FF60AF;">{{ item.role_name }}</span>
                                </div>
                                <div style="text-align: left;">总场数<span style="color: #2828FF;font-weight: bold;font-size: 16px;">{{ item.num }}</span>场</div>
                                <div style="text-align: left;">胜率<span style="color: #8600FF;font-weight: bold;font-size: 16px;">{{ item.win_ratio }}%</span></div>
                            </el-col>
                        </el-col>
                    </el-row>
                </el-descriptions-item>
                <el-descriptions-item>
                    <template slot="label">
                        <span>常玩<span style="font-size: 16px;">伙伴</span></span>
                    </template>
                    <el-row :gutter="20">
                        <el-col :span="8" v-for="item in YearlyPartner" :key="item.name">
                            <el-col :span="10">
                                <div style="text-align: center;"><img :src="item.picture" height="120px" alt="" style="border-radius: 10px;"></div>
                            </el-col>
                            <el-col :span="14">
                                <div style="text-align: left;margin-top: 20px;">
                                    <img v-if="item.gender === 1" :src="$store.state.baseURL+'icon/xingbienan.png'" height="14px"><span v-if="item.gender === 1" style="color: #2894FF;">{{ item.name }}</span>
                                    <img v-if="item.gender === 2" :src="$store.state.baseURL+'icon/xingbienv.png'" height="14px"><span v-if="item.gender === 2" style="color: #FF60AF;">{{ item.name }}</span>
                                </div>
                                <div style="text-align: left;">共同对局<span style="color: #2828FF;font-weight: bold;font-size: 16px;">{{ item.num }}</span>场</div>
                                <div style="text-align: left;">共同胜利<span style="color: #CE0000;font-weight: bold;font-size: 16px;">{{ item.all_win_num }}</span>场</div>
                                <div style="text-align: left;">共同失败<span style="color: #000000;font-weight: bold;font-size: 16px;">{{ item.all_lost_num }}</span>场</div>
                            </el-col>
                        </el-col>
                    </el-row>
                </el-descriptions-item>
            </el-descriptions>
            <div v-else-if="type === 'char'">
                <el-descriptions
                    :column="2"
                    :labelStyle="{'width':'110px','text-align':'center'}"
                    :contentStyle="{'text-align': 'center'}"
                    size="small"
                    border
                >
                    <el-descriptions-item>
                        <template slot="label">
                            <span>数据时间</span>
                        </template>
                        <el-radio-group v-model="cond.type" size="mini" fill='#9393FF' @change="get_char_data">
                            <el-radio-button label='month'>近一个月</el-radio-button>
                            <el-radio-button label='year'>近一年</el-radio-button>
                        </el-radio-group>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <span>对局模式</span>
                        </template>
                        <el-radio-group v-model="cond.mode" size="mini" fill='#9393FF' @change="get_char_data">
                            <el-radio-button label=''>不限</el-radio-button>
                            <el-radio-button :label=1>身份模式</el-radio-button>
                            <el-radio-button :label=2>3V3模式</el-radio-button>
                            <el-radio-button :label=3>酱油模式</el-radio-button>
                        </el-radio-group>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <span>对局人数</span>
                        </template>
                        <el-radio-group v-model="cond.usernum" size="mini" fill='#9393FF' @change="get_char_data">
                            <el-radio-button label=''>不限</el-radio-button>
                            <el-radio-button label='5人及以上'>5人及以上</el-radio-button>
                        </el-radio-group>
                    </el-descriptions-item>
                    <el-descriptions-item>
                        <template slot="label">
                            <span>对局身份</span>
                        </template>
                        <el-radio-group v-model="cond.identity" size="mini" fill='#9393FF' @change="get_char_data">
                            <el-radio-button label=''>不限</el-radio-button>
                            <el-radio-button :label=0>军情</el-radio-button>
                            <el-radio-button :label=1>潜伏</el-radio-button>
                            <el-radio-button :label=2>酱油</el-radio-button>
                        </el-radio-group>
                    </el-descriptions-item>
                </el-descriptions>
                <!-- 引入图表 -->
                <div ref="userchar" style="width:100%;height:230px;margin-top: 3px;"></div>
            </div>
            <div slot="footer" v-if="type === 'online'">
                <el-button type="primary" plain @click="get_online_user">刷新</el-button>
                <!-- <el-button v-if="OnLineDate.is_yy" type="danger" plain @click="del_yy">取消预约</el-button>
                <el-button v-else type="warning" plain @click="YyDialogVisible = true">离线预约</el-button> -->
                <el-button plain @click="$emit('ExitReportDialog')">关闭</el-button>
            </div>
        </el-dialog>
        <yu-yue-dialog-component
            :YyDialogVisible="YyDialogVisible"
            @ExiYyDialog="ExiYyDialog"
        >
        </yu-yue-dialog-component>
    </div>
</template>

<script>
import { UserWeeklyRequest,UserYearlyRequest,UserYearlyPartnerRequest,UserCharRequest,OnLineUserRequest,DelYuYueRequest } from '@/network/user.js'
import YuYueDialogComponent from '@/components/index/YuYueDialogComponent'
import * as echarts from 'echarts';

export default {
    name:'',
    data(){
        return {
            login_loading: false,
            type: 'online',
            WeeklyData: {
                role_win_arr:{},
                role_lose_arr:{},
                my_all_num:0,
                my_win_num:0,
                my_lucky_role_arr:{},
                my_win_partner:{},
                my_lose_partner:{},
                my_xiajiucai_partner:{},
                my_kexing_partner:{}
            },
            YearlyData: {
                count_play_num: '',
                count_play_win_num: '',
                count_play_win_ratio: '',
                count_play_jun_num: '',
                count_play_jun_win_num: '',
                count_play_jun_win_ratio: '',
                count_play_qian_num: '',
                count_play_qian_win_num:'',
                count_play_qian_win_ratio:'',
                count_play_jiang_num: '',
                count_play_jiang_win_num:'',
                count_play_jiang_win_ratio:'',
                count_play_shenfen_num: '',
                count_play_shenfen_win_num:'',
                count_play_shenfen_win_ratio:'',
                count_play_sansan_num: '',
                count_play_sansan_win_num: '',
                count_play_sansan_win_ratio: '',
                count_play_jiangyou_num: '',
                count_play_jiangyou_win_num: '',
                count_play_jiangyou_win_ratio: '',
                day_play_last_time:{
                    day:'',
                    time:'',
                    shihou: '',
                    win_lose:''
                }
            },
            YearlyPartner: [],
            echarDate: [],
            cond: {
                type: 'month',
                mode: '',
                usernum: '',
                identity: ''
            },
            OnLineDate: {
                wait: [],
                ing: [],
                gm: [],
                yy: [],
                is_yy: true
            },
            YyDialogVisible: false
        }
    },
    computed:{
        echar_title() {
            return this.cond.type === 'month' ? '近一个月数据分析' : '近一个年数据分析';
        }
    },
    methods:{
        get_user_weekly_data() {
            this.login_loading = true
            UserWeeklyRequest()
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.WeeklyData = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        get_user_yearly_data() {
            this.login_loading = true
            UserYearlyRequest()
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.YearlyData = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        get_user_yearly_partner_data() {
            this.login_loading = true
            UserYearlyPartnerRequest()
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.YearlyPartner = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        get_char_data() {
            this.login_loading = true
            UserCharRequest(this.cond)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.echarDate = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        update_echars() {
            if(this.type === 'char') {
                let myChart = echarts.init(this.$refs.userchar)

                let option = {
                    title: {
                        text: this.echar_title,
                        left: '50',
                        textStyle: {
                            color: '#8600FF',
                            fontWeight: 'normal',
                            fontSize: '13'
                        }
                    },
                    grid: {
                        top: 30,
                        bottom: 30,
                        right: 10
                    },
                    legend: {
                        orient: 'horizontal'
                    },
                    dataset: {
                        source:this.echarDate
                    },
                    xAxis: {
                        type: 'category'
                    },
                    yAxis: {},
                    tooltip: {
                        trigger: 'axis'
                    },
                    series: [
                        {
                            name: '总场数',
                            type: 'line',
                            itemStyle: {color: '#0080FF'}
                        },
                        {
                            name: '胜场',
                            type: 'line',
                            itemStyle: {color: '#CE0000'}
                        },
                        { 
                            name: '死亡',
                            type: 'line',
                            itemStyle: {color: '#000000'}
                        }
                    ]
                }
                myChart.setOption(option)
                window.addEventListener('resize', function() {
                    myChart.resize();
                });
            }
        },
        get_online_user() {
            this.login_loading = true
            OnLineUserRequest()
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.OnLineDate = s.result
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        },
        ExiYyDialog() {
            this.YyDialogVisible = false
            this.get_online_user()
        },
        del_yy() {
            this.login_loading = true
            DelYuYueRequest()
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('已取消!')
                        this.get_online_user()
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    console.log(err)
                })
        }
    },
    filters:{},
    props:{
        ReportDialogVisible: {
            type: Boolean,
            default() {
                return false
            }
        }
    },
    created(){
        this.get_user_weekly_data()
        this.get_user_yearly_data()
        this.get_user_yearly_partner_data()
        this.get_char_data()
        this.get_online_user()
    },
    beforeDestroy(){},
    mounted(){},
    updated(){
        this.update_echars()
    },
    components:{
        YuYueDialogComponent
    },
    watch:{
        echarDate(newVal) {
            this.update_echars()
        }
    }
}
</script>

<style lang='less' scoped>
</style>